module.exports = __webpack_public_path__ + "static/img/xq-4.e215330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xq-4.png
// module id = exG8
// module chunks = 1